export default {
  getTipos(state) {
    return state.tipos
  },

  getPrazos(state) {
    return state.prazos
  },

  getVeiculos(state) {
    return state.veiculos
  },

  getTipo(state) {
    return state.tipo
  }
}
